import { cn } from '@/lib/utils'

interface LoadingSpinnerProps {
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

export function LoadingSpinner({ className, size = 'md' }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  }

  return (
    <div
      className={cn(
        'animate-spin rounded-full border-2 border-gray-300 border-t-primary',
        sizeClasses[size],
        className
      )}
    />
  )
}

interface LoadingProps {
  className?: string
  text?: string
}

export function Loading({ className, text = 'Cargando...' }: LoadingProps) {
  return (
    <div className={cn('flex items-center justify-center space-x-2 p-4', className)}>
      <LoadingSpinner />
      <span className="text-sm text-muted-foreground">{text}</span>
    </div>
  )
}

export function FullPageLoading() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-background/80 backdrop-blur-sm">
      <Loading />
    </div>
  )
}
